/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React, { useEffect } from 'react';
import queryString from 'query-string';
import { Container, Row, Col } from 'reactstrap';

import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import backgroundColor from './img/bcg_linca.jpg'
import logo from './img/logo.png'
import LoginForm from './LoginForm';

const Login = ({ location, translate }) => {
  useEffect(() => {
    document.title = 'LINCA - Fibra e TV - Foz Telecomunicações - TV Por Assinatura - Banda Larga';
    document.body.style.backgroundImage = `url(${backgroundColor})`;
    document.body.style.backgroundRepeat = 'no-repeat';
  });
  const api = new ServiceApi();
  const parameters = queryString.parse(location.search);
  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type)
      return false;
    return true;
  }

  return (
    <Container fluid={true} className="netfoz-body">
      <Row className="img-container-netfoz">
        <img src={logo} alt="logo" className="logo-netfoz rounded mx-auto d-block" />
      </Row>
      <Row>
        <Col>
          {
            _validateParams()
              ? <LoginForm
                api={api}
                location={location}
              />
              : <RequestLoginErrorMessage
                onlyMessage={true}
                message={translate('RequestLoginErrorMessage')}
              />
          }
        </Col>
      </Row>
    </Container>
  );
}

export default Login;
